export default __webpack_public_path__ + "static/media/4.318271f6.png";